<card *ngIf="!(responsiveService.mdBelow | async)">
    <div card-body class="invoice-table">
        <lsq-data-table
            *ngIf="dataSource"
            [hasHeader]="true"
            [dataSource]="dataSource"
            [isPaginated]="false"
            [layoutFixed]="true"
            [trackBy]="trackByPendingKeys"
            [appearance]="tableAppearance.Default"
            [getRowClassName]="getCreditMemosRowClassNameBound"
        >
            <lsq-column
                [column]="{
                    key: 'isGroup',
                    width: '4.5rem',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row" let-index="index">
                    <div [style.padding-top]="0" [style.padding-bottom]="0">
                        <ng-container *ngIf="row.isGroup">
                            <div class="invoice-group-expand-button" [class.disabled]="true">
                                <lsq-icon [type]="icons.ChevronDown" [color]="color.Black">
                                </lsq-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!row.isGroup">
                            {{ index }}
                        </ng-container>
                    </div>
                </ng-template>
            </lsq-column>
            <lsq-column
                [column]="{
                    header: invoiceNumberI18n,
                    key: 'invoiceNumber',
                    width: '20%',
                    truncateAfter: invoiceNumberTruncateAfter$ | async,
                    reverseTruncate: true,
                    onCellClick: goToPendingCredMemoDetailBound,
                    sortable: false,
                    isClickableFunction: isInvoiceClickableBound
                }"
            >
            </lsq-column>
            <lsq-column
                [column]="{
                    header: invoiceStatusI18n,
                    key: 'fundingStatus',
                    width: '11rem',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <status-pill
                        [status]="row.status || ineligibleStatus"
                        [color]="statusColor[row.status || ineligibleStatus]"
                        [displayValueMap]="invoiceFundingStatusDisplay"
                    >
                    </status-pill>
                </ng-template>
            </lsq-column>
            <lsq-date-column
                [isShortDate]="true"
                [alignRight]="true"
                [column]="{
                    header: invoiceDateI18n,
                    key: 'invoiceDate',
                    width: '11%',
                    sortable: false
                }"
            >
            </lsq-date-column>
            <lsq-column
                [column]="{
                    key: 'dueIn',
                    header: dueInI18n,
                    width: '9rem',
                    sortable: false,
                    className: 'column-dueIn'
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    {{ row.dueIn | days }}
                </ng-template>
            </lsq-column>
            <lsq-date-column
                [isShortDate]="true"
                [column]="{
                    header: dueDateI18n,
                    key: 'dueDate',
                    width: '11%',
                    sortable: false
                }"
            >
            </lsq-date-column>
            <lsq-currency-column
                [column]="{
                    header: invoiceAmountI18n,
                    key: 'invoiceAmount',
                    width: '15%',
                    sortable: false
                }"
            >
            </lsq-currency-column>
        </lsq-data-table>
    </div>
</card>
<div *ngIf="(responsiveService.mdBelow | async) && !!dataSource">
    <card id="mobile-credit-memo-card">
        <div left-header-content>
            <div>
                {{ pendingGroupI18n }}:
                <strong>{{ (dataSource.rows$ | async)[0].invoiceNumber }}</strong>
            </div>
            <div>
                {{ invoiceAmountI18n }}:
                <strong>{{ (dataSource.rows$ | async)[0].invoiceAmount | lsqCurrency }}</strong>
            </div>
            <status-pill
                [status]="ineligibleStatus"
                [color]="color.Red"
                [displayValueMap]="invoiceFundingStatusDisplay"
            >
            </status-pill>
        </div>
        <div card-body>
            <div
                *ngFor="let row of dataSource.rows$ | async | slice: 1; let i = index"
                class="mobile-credit-memo-card-pending-item"
            >
                <div>
                    {{ invoiceNumberI18n }}: <strong>{{ row.invoiceNumber }}</strong>
                </div>
                <div>
                    {{ invoiceDateI18n }}:
                    <strong>{{
                        row.invoiceDate ? (row.invoiceDate | date: lsqShortDateFormat) : nullValue
                    }}</strong>
                </div>
                <div>
                    {{ dueDateI18n }}:
                    <strong>{{
                        row.dueDate ? (row.dueDate | date: lsqShortDateFormat) : nullValue
                    }}</strong>
                </div>
                <div>
                    {{ invoiceAmountI18n }}: <strong>{{ row.invoiceAmount | lsqCurrency }}</strong>
                </div>
                <status-pill
                    [status]="row.status || ineligibleStatus"
                    [color]="statusColor[row.status || ineligibleStatus]"
                    [displayValueMap]="invoiceFundingStatusDisplay"
                >
                </status-pill>
                <div
                    *ngIf="i < (dataSource.rows$ | async | slice: 1).length - 1"
                    class="mobile-pending-credit-memo-divider"
                ></div>
            </div>
        </div>
    </card>
</div>
